import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, ActivationEnd, Event, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent, RoutesRecognized} from '@angular/router';
import {Subject, filter, takeUntil, map} from 'rxjs';
import {FuseMediaWatcherService} from '@fuse/services/media-watcher';
import {FuseNavigationService, FuseVerticalNavigationComponent} from '@fuse/components/navigation';
import {Navigation} from 'app/core/navigation/navigation.types';
import {NavigationService} from 'app/core/navigation/navigation.service';
import { UserSigninService } from '../../../../shared/services/user-signin.service';
import { TranslateService } from '@ngx-translate/core';
import { IGAEADLookupService } from 'app/shared/services/igaead-lookup.service';
import { IGovService } from 'app/shared/services/igov.service';
@Component({
    selector: 'classic-layout',
    templateUrl: './classic.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./classic.component.scss'],

})
export class ClassicLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    currentRoute;
    title: string;
    breadcrumbs = [];
    isLtr = true;
    parentRoute :string;
    currentLang :string;
    isRefreshed = true; // dummy variable flag
    showBanner = false;
    public isMobile: boolean = false;
    deviceWindow = window as any;
    openMobileLang=false;
    openMobileMenu = false;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private activatedRoute: ActivatedRoute,
        public userSigninService: UserSigninService,
        public translateService: TranslateService,
        public lookupService: IGAEADLookupService,
        public igovService: IGovService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    isMobileScreen() {
        return this.deviceWindow.innerWidth <= 768;
    }
    get currentYear(): number {
        return new Date().getFullYear();
    }

    openLang(){
        this.openMobileLang = !this.openMobileLang;
    }

    openMenu(){
        this.openMobileMenu = !this.openMobileMenu;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    getChild(activatedRoute: ActivatedRoute) {
        if (activatedRoute.firstChild) {
          return this.getChild(activatedRoute.firstChild);
        } else {
          return activatedRoute;
        }
    }
    
    ngOnInit(): void {
        this.isLtr = localStorage.getItem('defaultLanguage') =='ar' ? false : true;
        this.currentLang = localStorage.getItem('defaultLanguage');
        //this.translate.setDefaultLang('es');
        this.isMobile = this.isMobileScreen();
        if (this.isRefreshed) {
            var rt = this.getChild(this.activatedRoute)
                rt.data.subscribe(data => {
                let mainBody = this.lookupService.mainBody(this.router.url);
                if(mainBody == 'GA'){
                    this.title = 'General Assembly'
                }
                else if(mainBody == 'Conferences'){
                    this.title = 'Conferences'
                }
                else if(mainBody == 'Economic and Social Council'){
                    this.title = 'Economic and Social Council'
                }
                else{
                    this.title = data.title;
                }
                if(data.showBanner){
                    this.showBanner = true;
                }
                else{
                    this.showBanner = false;
                }
            })
        }
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd || event instanceof ActivationEnd),
          )
          .subscribe(() => {
            var rt = this.getChild(this.activatedRoute)
                rt.data.subscribe(data => {
                let mainBody = this.lookupService.mainBody(this.router.url);
                if(mainBody == 'GA'){
                    this.title = 'General Assembly'
                }
                else if(mainBody == 'Conferences'){
                    this.title = 'Conferences'
                }
                else if(mainBody == 'Economic and Social Council'){
                    this.title = 'Economic and Social Council'
                }
                else{
                    this.title = data.title;
                }
                if(data.showBanner){
                    this.showBanner = true;
                }
                else{
                    this.showBanner = false;
                }
            })
        });

        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    isActive(menu){
        let mainBody = this.router.url.split('/')[1];
        return menu.activeIdentifire == mainBody
    }

    getLanguage(lang){
        switch(lang){
            case 'en':
                return 'English';
            case 'ar':
                return 'العربية'
            case 'zh':
                return '中文'
            case 'ru':
                return 'Русский'
            case 'es':
                return 'Español'
            case 'fr':
                return 'Français'
        }
    }
}
